import { FiltroInicial } from "../models/clientesFornecedorModel"
import type { ClientesFornecedorState } from "../models/clientesFornecedorModel"
import {
    ClientesFornecedorActionsTypes,
    ClientesFornecedorAction,
} from "./clientesFornecedorActions"

export function clientesFornecedorReducer(
    state: ClientesFornecedorState,
    action: ClientesFornecedorAction
): ClientesFornecedorState {
    switch (action.type) {
        case ClientesFornecedorActionsTypes.CARREGAR_RESULTADO:
            return {
                ...state,
                clientes: action.payload.clientes,
                total: action.payload.total,
            }
        case ClientesFornecedorActionsTypes.ATUALIZAR_FILTRO_CAMPO:
            return {
                ...state,
                filtro: { ...state.filtro, [action.payload.campo]: action.payload.valor },
            }
        case ClientesFornecedorActionsTypes.MUDAR_PAGINA:
            return { ...state, pagina: action.payload.pagina }
        case ClientesFornecedorActionsTypes.LIMPAR_FILTRO:
            return { ...state, filtro: FiltroInicial, pagina: 0 }
        default:
            return state
    }
}
